import { PROGRESS_START, PROGRESS_FINISH } from "../../mutation-types";
import apiReceipt from "@/api/receipt";
import helperReceipt from "@/helpers/receipt";

const defaultState = () => ({
	listReceipt: [],
	pagination: '',
	detailSO: {},
	detailReceipt: {},
	konfirmResponse: {},
	responSukses: '',
	dataSerial: helperReceipt.getSerialData(),
	serialInvalid: [],
  sold_platform: ['pos', 'store'],
});

const state = defaultState();

const getters = {};

const mutations = {
	setReceipt(state, data) {
		state.listReceipt = data.data;
		state.pagination = data.pagination;
	},
	setDetailSO(state, data) {
		state.detailSO = data.results;
	},
	setDetailReceipt(state, data) {
    data.results.detail.map(el => {
      el.serialProduct = {};
      state.sold_platform.forEach(platform => {
        el.serialProduct[platform] = {
          quantity: 0,
          serial: [],
        }
      });
      return el
    });
		state.detailReceipt = data.results
	},
	refreshListSerial(state) {
		state.dataSerial = helperReceipt.getSerialData()
	},
	setSerialInvalid(state, data) {
		state.serialInvalid = data
	},
	saveConfirmResponse(state, data) {
		state.konfirmResponse = {};
		state.konfirmResponse = data;
	},
	konfirmasiSukses(state, data) {
		state.responSukses = '';
		state.responSukses = data;
	},
};

const actions = {
	getReceipt({ commit }, value) {
		commit(PROGRESS_START, null, { root: true });
		commit(PROGRESS_START, null, { root: true });
		apiReceipt.getReceipt({ 'limit': value.limit, 'page': value.page }).then(({ data: { data } }) => {
			if (data.results.length == 0) {
				commit('setReceipt', { data: 'error', pagination: data.pagination, product: 'error', summary: 'error' });
			} else {
				commit("setReceipt", { data: data.results, pagination: data.pagination });
			}
			commit(PROGRESS_FINISH, null, { root: true });
		});
	},
	getDetailSO({ commit }, param) {
		return new Promise (async (resolve, reject) => {
			commit("setDetailSO", {});
			commit(PROGRESS_START, null, { root: true });
			apiReceipt.getDetailSO(param).then(({ data: { data } }) => {
				commit("setDetailSO", data);
				commit(PROGRESS_FINISH, null, { root: true });
				resolve()
			}).catch(({response: { data } }) => {
				reject(data.message)
			});
		})
	},
	getDetailReceipt({ commit }, param) {
		return new Promise (async (resolve, reject) => {
			commit(PROGRESS_START, null, { root: true });
			apiReceipt.getDetailReceipt(param).then(({ data: { data } }) => {
				commit("setDetailReceipt", data);
				commit(PROGRESS_FINISH, null, { root: true });
				resolve()
			}).catch(res => {
        reject(res)
      });
      // .catch(({response: { data } }) => {
			// 	reject(data.message)
			// });
		})
	},
	async addReceipt({ commit }, value) {
		return new Promise (async (resolve, reject) => {
			commit("konfirmasiSukses", '');
			commit(PROGRESS_START, null, { root: true });
			await apiReceipt.addReceipt(value).then(res => {
				const data = res.data.code;
				commit("konfirmasiSukses", data);
				resolve()
			}).catch( ({response: { data } }) => {
				if (data.message == 'error_validation') {
					const res = data.data
					commit("saveConfirmResponse", res);
				} else {
					commit("saveConfirmResponse", {
						sdo_code: data.message
					});
				}
				reject()
			});
		})
	},
	getSerialStashed({ commit }, value) {
		return new Promise (async (resolve, reject) => {
			await apiReceipt.getSerialStashed(value).then(res => {
				const data = res.data;
				if (data.data.results) {
					// var serial_stashed = helperReceipt.getSerialData()
					var serial = {
						sdo_id: value.sdo_id,
						product_id: value.product_id,
						product_is_serial: value.product_is_serial,
						serial: data.data.results
					}
					helperReceipt.setSerialData(serial)
				}
				commit("konfirmasiSukses", data.code);
				resolve(true)
			}).catch(err => {
				const data = err.response.data
				commit("saveConfirmResponse", data);
				reject(true)
			})
		})
	},
	syncSerial({ commit }, {value, index}) {
		return new Promise (async (resolve, reject) => {
			commit("konfirmasiSukses", '');
			commit(PROGRESS_START, null, { root: true });
			// var serial = await helperReceipt.getSerialData()
			// var sdo = serial.findIndex(el => el.sdo_id == value.sdo_id)
			await apiReceipt.syncSerial(value).then(res => {
				const data = res.data.code;
				commit("konfirmasiSukses", data);
				/*kalau ga ada yang valid, muncul alert, alert bawa index yang dari input form, klik oke di alert, hilangkan data di input form nya*/
				var serial_invalid = res.data.data.serial_invalid.map(el => el.serial)
				if (serial_invalid.length > 0) {
					reject(true)
					commit('setSerialInvalid', index)
				} else {
					resolve(true)
				}
			}).catch(err => {
				if (err.response) {
					reject(true)
					const data = err.response.data
					commit("saveConfirmResponse", data);
				}
			});
			await commit('refreshListSerial');
			await commit(PROGRESS_FINISH, null, { root: true });
		})
	},
	async proccessSerial({ commit }, value) {
		return new Promise (async (resolve, reject) => {
			commit("konfirmasiSukses", '');
			commit(PROGRESS_START, null, { root: true });
			await apiReceipt.proccessSerial(value).then(res => {
				helperReceipt.setSerialData(null)
				const data = res.data.code;
				commit("konfirmasiSukses", data);
				resolve()
			}).catch(err => {
				const data = err.response.data.message
				reject(data)
				commit("saveConfirmResponse", data);
			});
		})
	},

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
